var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-to-top position-fixed",class:{ 'show': !_vm.showScrollTopButton }},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"d-block text-center text-white rounded",attrs:{"href":"#app"}},[_c('i',{staticClass:"fa fa-chevron-up"})])
}]

export { render, staticRenderFns }